

(function () {
  'use strict';



  var openModal = null;
  var bodyOverflowBackup = '';

  function openTargetModal(id) {
    var modal = document.getElementById(id);
    if (!modal || !modal.classList.contains('cerus-modal')) return;

    if (openModal) closeOpenModal();

    openModal = modal;
    bodyOverflowBackup = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    var focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);

    document.dispatchEvent(new CustomEvent('cerus:modal-open', { detail: { id: id, modal: modal } }));
  }

  function closeOpenModal() {
    if (!openModal) return;
    var modal = openModal;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = bodyOverflowBackup;
    openModal = null;
    document.dispatchEvent(new CustomEvent('cerus:modal-close', { detail: { modal: modal } }));
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cerus-modal-open]');
    if (opener) {
      e.preventDefault();
      openTargetModal(opener.getAttribute('data-cerus-modal-open'));
      return;
    }

    var closer = e.target.closest('[data-cerus-modal-close]');
    if (closer && openModal) {
      e.preventDefault();
      closeOpenModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openModal) closeOpenModal();
  });



  function initReveals() {
    var nodes = document.querySelectorAll('[data-cerus-gsap-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }



  function initParallax() {
    var nodes = document.querySelectorAll('[data-cerus-parallax]');
    if (!nodes.length) return;

    var ticking = false;
    var visible = new Set();

    function update() {
      visible.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        var rel = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
        var strength = parseFloat(el.dataset.cerusParallaxStrength) || 0.18;
        var offset = -(rel * viewportHeight * strength);
        el.style.setProperty('--cerus-parallax-y', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        update();
      }, { threshold: 0 });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(function (n) { visible.add(n); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }



  function init() {
    initReveals();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initReveals);

  window.CerusModal = {
    open: openTargetModal,
    close: closeOpenModal
  };
})();
